exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Internet_page_1_zR {}\n\n.Internet_price_1wZ5 {\n  font-size: 21px;\n\n  color: #282828;\n}\n\n.Internet_error_kOvk {\n  max-width: none;\n\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"page": "Internet_page_1_zR",
	"price": "Internet_price_1wZ5",
	"error": "Internet_error_kOvk"
};